import { Avatar } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import {
  DeniedStep,
  LastStep,
  PurpleCheckMark,
  RequestsStepperActive,
  StepperIcon,
} from 'Images';

export interface ICustomStepperIcon {
  active: boolean;
  completed: boolean;
  isLastStep: boolean;
  isDenied: boolean;
}

export const CustomStepperIcon = ({
  active,
  completed,
  isLastStep,
  isDenied,
}: ICustomStepperIcon) => {
  const isDesktop = useIsDesktop();

  let avatarSrc = () => {
    if (isLastStep) return isDenied ? DeniedStep : LastStep;
    if (active) return RequestsStepperActive;
    if (completed) return PurpleCheckMark;
    return StepperIcon;
  };

  return (
    <Avatar
      src={avatarSrc()}
      alt=''
      sx={{
        width: '24px',
        height: '24px',
      }}
    />
  );
};
